import React from 'react'
import { CloseOutlined, PlusOutlined } from '@ant-design/icons'
import { Button } from 'antd'

type EdgeActionProps = {
    visible: boolean
    onClick?: React.MouseEventHandler<HTMLElement>
}

export const EdgeAction = ({ visible, onClick }: EdgeActionProps) => {
    let icon: React.ReactNode
    let ariaLabel: string
    if (visible) {
        icon = <CloseOutlined />
        ariaLabel = 'Close add step panel'
    } else {
        icon = <PlusOutlined />
        ariaLabel = 'Add step'
    }

    return (
        <Button
            size="small"
            type="primary"
            shape="circle"
            className="nodrag nopan journey-edge-action-add"
            onClick={onClick}
            aria-label={ariaLabel}
        >
            {icon}
        </Button>
    )
}
